import { getToken } from "firebase/messaging";
import { messaging } from "./firebase-config";

const VAPID_KEY =
  "BAy9wUaY2iGND6TpNUTTBCs36ttXgBTlNMDjONL6Gj7RIXaiGiCiDou7DhXKoxP2HYBsT8SamBnI6nGEjpZG4hs";

let currentFcmToken = null;

// Sadece izin ister ve Token döndürür (Backend'e yollamaz)
export const requestPermissionAndGetToken = async () => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === "granted") {
      console.log("Bildirim izni alındı.");
      const token = await getToken(messaging, { vapidKey: VAPID_KEY });

      if (token) {
        console.log("FCM Token alındı:", token);
        currentFcmToken = token;
        return token; // Sadece token'ı döndür
      }
    } else {
      console.log("Bildirim izni verilmedi.");
    }
  } catch (err) {
    console.error("FCM token alınırken hata oluştu:", err);
  }
  return null;
};

// Sessizce güncel token'ı alır ve döner (Backend'e yollamaz)
export const refreshFcmToken = async () => {
  try {
    if (!("Notification" in window) || Notification.permission !== "granted") {
      return null;
    }
    const token = await getToken(messaging, { vapidKey: VAPID_KEY });
    if (token) {
      if (currentFcmToken !== token) {
        currentFcmToken = token;
        return token; // Sadece farklıysa yeni token'ı döndür
      }
      return token; // Aynıysa mevcut token'ı döndür
    }
  } catch (err) {
    console.warn("FCM token arka planda alınırken sessiz hata:", err.message);
  }
  return null;
};

// Layout'larda kullanabilmen için alias ekliyorum
export const checkAndRefreshFcmToken = refreshFcmToken;
